import { Box } from '@mui/material';
// eslint-disable-next-line no-restricted-imports -- standalone client-side history view, no server-side pagination
import { DataGridPro } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function PowerConsumptionGrid({ list }) {
  const { t } = useTranslation();

  const rows = useMemo(
    () =>
      list.toArray().map((row, idx) => ({
        id: row.get('id', idx),
        moment: row.get('moment'),
        consumed_energy: row.get('consumed_energy'),
      })),
    [list],
  );

  const columns = useMemo(
    () => [
      {
        field: 'moment',
        headerName: t('general.date'),
        width: 180,
        valueFormatter: value => (value ? format(value, 'P') : ''),
      },
      {
        field: 'consumed_energy',
        headerName: t('powerData.energyConsumedKwh', { defaultValue: 'Energy Consumed (kWh)' }),
        flex: 1,
        minWidth: 180,
        sortable: false,
      },
    ],
    [t],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        density="compact"
        disableRowSelectionOnClick
        hideFooter
        initialState={{ sorting: { sortModel: [{ field: 'moment', sort: 'desc' }] } }}
        localeText={{ noRowsLabel: t('general.noResultsMessage', { defaultValue: 'No data' }) }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Box>
  );
}

export default PowerConsumptionGrid;
